import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { projectQuery, useProject } from "@/api/projects";
import { ProjectHeader } from "@/components/projects/ProjectHeader";
import { ChatDock } from "@/components/chat/ChatDock";
import { cn } from "@/lib/utils";

export const Route = createFileRoute("/_app/projects/$projectId")({
  loader: ({ context, params }) => context.queryClient.ensureQueryData(projectQuery(params.projectId)),
  component: ProjectLayout,
});

const TABS = [
  { to: "/projects/$projectId", label: "Overview", exact: true },
  { to: "/projects/$projectId/sources", label: "Sources" },
  { to: "/projects/$projectId/activity", label: "Activity" },
] as const;

function ProjectLayout() {
  const { projectId } = Route.useParams();
  const project = useProject(projectId);
  if (!project.data) return null;
  const p = project.data;
  return (
    <div className="flex min-h-[calc(100vh-49px)]">
      <div className="flex min-w-0 flex-1 flex-col">
        <ProjectHeader project={p} />
        <nav className="flex gap-1 border-b px-6">
          {TABS.map((t) => (
            <Link
              key={t.to}
              to={t.to}
              params={{ projectId }}
              activeOptions={{ exact: "exact" in t && t.exact }}
              className={cn("-mb-px border-b-2 border-transparent px-2 py-2 text-sm text-muted-foreground hover:text-foreground")}
              activeProps={{ className: "border-primary text-foreground" }}
            >
              {t.label}
            </Link>
          ))}
        </nav>
        <div className="flex-1">
          <Outlet />
        </div>
      </div>
      <ChatDock projectId={p.id} />
    </div>
  );
}
